import React, { Component } from 'react'
import LoadingIcon from '../assets/Double Ring-1s-200px.svg'

class Loading extends Component{

    render(){
        const text = this.props.text || 'Loading...'
        return(
            <React.Fragment>
                <div className="modal show" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" 
                style={{display: 'block'}}>
                    <div className="modal-dialog" role="document" style={{textAlign: 'center', position: 'relative',top: '20%'}}>
                        {/*<img align="middle" width="60%" src={LoadingIcon} />*/}
                        <div align="middle" width="60%" className="lds-css ng-scope"><div style={{width:'100%',height:'100%'}} className="lds-double-ring"><div></div><div></div></div></div>
                        <h4 style={{color:'#fff', fontSize:'40px'}}>{text}</h4>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </React.Fragment>
        )
    }
}

export default Loading


// WEBPACK FOOTER //
// ./src/components/Loading.js